import React from 'react';
import { getProducts } from 'util/hasProductCode';
import { gql } from '@apollo/client';
import flow from 'lodash/fp/flow';
import keyBy from 'lodash/fp/keyBy';
import mapValues from 'lodash/fp/mapValues';
import useSuspendableQuery from 'hooks/useSuspendableQuery';

const GET_PRODUCT_COLLECTION = gql`
  query getProductCollection {
    contentfulKnowHowProductCollection {
      items {
        name
        productCode
        practiceAreaCollection {
          items {
            slug
          }
        }
      }
    }
  }
`;

const remapToSlugs = flow(
  keyBy('productCode'),
  mapValues(product =>
    product.practiceAreaCollection.items.map(({ slug }) => slug),
  ),
);

export function useProductCollectionSlugs(assets, productCode) {
  const { data } = useSuspendableQuery(GET_PRODUCT_COLLECTION);
  const [availableProductSlugs, setAvailableProductSlugs] = React.useState(
    null,
  );

  React.useEffect(() => {
    if (assets) {
      const availableProducts = getProducts(assets, productCode, false);

      const productSlugs = remapToSlugs(
        data?.contentfulKnowHowProductCollection.items,
      );

      setAvailableProductSlugs(
        availableProducts
          .map(({ productCode }) => productSlugs[productCode])
          .filter(Boolean)
          .reduce((t, v) => t.concat(v), []),
      );
    }
  }, [assets]);

  return { availableProductSlugs };
}
